module.exports = __webpack_public_path__ + "img/hot.4123d939.png";